// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as StockQuantity from "../../core/StockQuantity.res.js";
import * as Client from "@apollo/client";
import * as CatalogVariant from "./CatalogVariant.res.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as CatalogProductEditFormMutations from "./CatalogProductEditFormMutations.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let CreateProductAndVariant_ProductValuesNotFound = /* @__PURE__ */Primitive_exceptions.create("CatalogVariantEditFormMutations.CreateProductAndVariant_ProductValuesNotFound");

let CreateVariantInput_NameError = /* @__PURE__ */Primitive_exceptions.create("CatalogVariantEditFormMutations.CreateVariantInput_NameError");

let CreateVariantInput_CapacityValueError = /* @__PURE__ */Primitive_exceptions.create("CatalogVariantEditFormMutations.CreateVariantInput_CapacityValueError");

let CreateVariantInput_StockThresholdsInvalid = /* @__PURE__ */Primitive_exceptions.create("CatalogVariantEditFormMutations.CreateVariantInput_StockThresholdsInvalid");

let CreateVariant_FormIdNotFound = /* @__PURE__ */Primitive_exceptions.create("CatalogVariantEditFormMutations.CreateVariant_FormIdNotFound");

let CreateVariant_ShopIdNotFound = /* @__PURE__ */Primitive_exceptions.create("CatalogVariantEditFormMutations.CreateVariant_ShopIdNotFound");

let CreateVariant_DeviceIdNotFound = /* @__PURE__ */Primitive_exceptions.create("CatalogVariantEditFormMutations.CreateVariant_DeviceIdNotFound");

let UpdateVariantInput_NameError = /* @__PURE__ */Primitive_exceptions.create("CatalogVariantEditFormMutations.UpdateVariantInput_NameError");

let UpdateVariant_FormIdNotFound = /* @__PURE__ */Primitive_exceptions.create("CatalogVariantEditFormMutations.UpdateVariant_FormIdNotFound");

let Raw = {};

let query = Client.gql(["mutation createVariant($input: InputCreateVariant!, $variantPricesInput: [InputCreateVariantPrices!]!)  {\ncreateVariant(input: $input, variantPricesInput: $variantPricesInput)  {\n__typename  \nid  \ncku  \npurchasedPrice  \nname  \nformattedName  \ncapacityValue  \ncapacityUnit  \ncapacityPrecision  \nyear  \nalcoholVolume  \nean13  \nstockKeepingUnit  \npriceLookUpCode  \ninternalCode  \nmaxStockThreshold  \nminStockThreshold  \nstockOrderTriggerThreshold  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.createVariant;
  let value$2 = value$1.purchasedPrice;
  let value$3 = value$1.capacityValue;
  let value$4 = value$1.capacityUnit;
  let value$5 = value$1.capacityPrecision;
  let value$6 = value$1.year;
  let value$7 = value$1.alcoholVolume;
  let value$8 = value$1.ean13;
  let value$9 = value$1.stockKeepingUnit;
  let value$10 = value$1.priceLookUpCode;
  let value$11 = value$1.internalCode;
  let value$12 = value$1.maxStockThreshold;
  let value$13 = value$1.minStockThreshold;
  let value$14 = value$1.stockOrderTriggerThreshold;
  return {
    createVariant: {
      __typename: value$1.__typename,
      id: value$1.id,
      cku: Scalar.CKU.parse(value$1.cku),
      purchasedPrice: !(value$2 == null) ? value$2 : undefined,
      name: value$1.name,
      formattedName: value$1.formattedName,
      capacityValue: !(value$3 == null) ? value$3 : undefined,
      capacityUnit: !(value$4 == null) ? value$4 : undefined,
      capacityPrecision: !(value$5 == null) ? value$5 : undefined,
      year: !(value$6 == null) ? value$6 : undefined,
      alcoholVolume: !(value$7 == null) ? value$7 : undefined,
      ean13: !(value$8 == null) ? value$8 : undefined,
      stockKeepingUnit: !(value$9 == null) ? value$9 : undefined,
      priceLookUpCode: !(value$10 == null) ? value$10 : undefined,
      internalCode: !(value$11 == null) ? value$11 : undefined,
      maxStockThreshold: !(value$12 == null) ? value$12 : undefined,
      minStockThreshold: !(value$13 == null) ? value$13 : undefined,
      stockOrderTriggerThreshold: !(value$14 == null) ? value$14 : undefined
    }
  };
}

function serialize(value) {
  let value$1 = value.createVariant;
  let value$2 = value$1.stockOrderTriggerThreshold;
  let stockOrderTriggerThreshold = value$2 !== undefined ? value$2 : null;
  let value$3 = value$1.minStockThreshold;
  let minStockThreshold = value$3 !== undefined ? value$3 : null;
  let value$4 = value$1.maxStockThreshold;
  let maxStockThreshold = value$4 !== undefined ? value$4 : null;
  let value$5 = value$1.internalCode;
  let internalCode = value$5 !== undefined ? value$5 : null;
  let value$6 = value$1.priceLookUpCode;
  let priceLookUpCode = value$6 !== undefined ? value$6 : null;
  let value$7 = value$1.stockKeepingUnit;
  let stockKeepingUnit = value$7 !== undefined ? value$7 : null;
  let value$8 = value$1.ean13;
  let ean13 = value$8 !== undefined ? value$8 : null;
  let value$9 = value$1.alcoholVolume;
  let alcoholVolume = value$9 !== undefined ? value$9 : null;
  let value$10 = value$1.year;
  let year = value$10 !== undefined ? value$10 : null;
  let value$11 = value$1.capacityPrecision;
  let capacityPrecision = value$11 !== undefined ? value$11 : null;
  let value$12 = value$1.capacityUnit;
  let capacityUnit = value$12 !== undefined ? value$12 : null;
  let value$13 = value$1.capacityValue;
  let capacityValue = value$13 !== undefined ? value$13 : null;
  let value$14 = value$1.formattedName;
  let value$15 = value$1.name;
  let value$16 = value$1.purchasedPrice;
  let purchasedPrice = value$16 !== undefined ? value$16 : null;
  let value$17 = value$1.cku;
  let value$18 = Scalar.CKU.serialize(value$17);
  let value$19 = value$1.id;
  let value$20 = value$1.__typename;
  let createVariant = {
    __typename: value$20,
    id: value$19,
    cku: value$18,
    purchasedPrice: purchasedPrice,
    name: value$15,
    formattedName: value$14,
    capacityValue: capacityValue,
    capacityUnit: capacityUnit,
    capacityPrecision: capacityPrecision,
    year: year,
    alcoholVolume: alcoholVolume,
    ean13: ean13,
    stockKeepingUnit: stockKeepingUnit,
    priceLookUpCode: priceLookUpCode,
    internalCode: internalCode,
    maxStockThreshold: maxStockThreshold,
    minStockThreshold: minStockThreshold,
    stockOrderTriggerThreshold: stockOrderTriggerThreshold
  };
  return {
    createVariant: createVariant
  };
}

function serializeInputObjectInputCreateVariant(inp) {
  let a = inp.stockKeepingUnit;
  let a$1 = inp.purchasedPrice;
  let a$2 = inp.year;
  let a$3 = inp.capacityValue;
  let a$4 = inp.capacityUnit;
  let a$5 = inp.capacityPrecision;
  let a$6 = inp.alcoholVolume;
  let a$7 = inp.ean13;
  let a$8 = inp.bulk;
  let a$9 = inp.packaging;
  let a$10 = inp.internalCode;
  let a$11 = inp.priceLookUpCode;
  let a$12 = inp.minStockThreshold;
  let a$13 = inp.maxStockThreshold;
  let a$14 = inp.stockOrderTriggerThreshold;
  let a$15 = inp.supplierId;
  return {
    stockKeepingUnit: a !== undefined ? a : undefined,
    name: inp.name,
    purchasedPrice: a$1 !== undefined ? a$1 : undefined,
    year: a$2 !== undefined ? a$2 : undefined,
    capacityValue: a$3 !== undefined ? a$3 : undefined,
    capacityUnit: a$4 !== undefined ? a$4 : undefined,
    capacityPrecision: a$5 !== undefined ? a$5 : undefined,
    alcoholVolume: a$6 !== undefined ? a$6 : undefined,
    ean13: a$7 !== undefined ? a$7 : undefined,
    bulk: a$8 !== undefined ? a$8 : undefined,
    packaging: a$9 !== undefined ? a$9 : undefined,
    internalCode: a$10 !== undefined ? a$10 : undefined,
    priceLookUpCode: a$11 !== undefined ? a$11 : undefined,
    minStockThreshold: a$12 !== undefined ? a$12 : undefined,
    maxStockThreshold: a$13 !== undefined ? a$13 : undefined,
    stockOrderTriggerThreshold: a$14 !== undefined ? a$14 : undefined,
    productId: inp.productId,
    supplierId: a$15 !== undefined ? a$15 : undefined,
    shopId: inp.shopId
  };
}

function serializeInputObjectInputCreateVariantPrices(inp) {
  let a = inp.fromQuantity;
  let a$1 = inp.toQuantity;
  return {
    valueIncludingTax: inp.valueIncludingTax,
    valueExcludingTax: inp.valueExcludingTax,
    fromQuantity: a !== undefined ? a : undefined,
    toQuantity: a$1 !== undefined ? a$1 : undefined,
    priceId: inp.priceId
  };
}

function serializeVariables(inp) {
  let a = inp.variantPricesInput;
  return {
    input: serializeInputObjectInputCreateVariant(inp.input),
    variantPricesInput: a.map(serializeInputObjectInputCreateVariantPrices)
  };
}

function makeVariables(input, variantPricesInput, param) {
  return {
    input: input,
    variantPricesInput: variantPricesInput
  };
}

function makeInputObjectInputCreateVariant(stockKeepingUnit, name, purchasedPrice, year, capacityValue, capacityUnit, capacityPrecision, alcoholVolume, ean13, bulk, packaging, internalCode, priceLookUpCode, minStockThreshold, maxStockThreshold, stockOrderTriggerThreshold, productId, supplierId, shopId, param) {
  return {
    stockKeepingUnit: stockKeepingUnit,
    name: name,
    purchasedPrice: purchasedPrice,
    year: year,
    capacityValue: capacityValue,
    capacityUnit: capacityUnit,
    capacityPrecision: capacityPrecision,
    alcoholVolume: alcoholVolume,
    ean13: ean13,
    bulk: bulk,
    packaging: packaging,
    internalCode: internalCode,
    priceLookUpCode: priceLookUpCode,
    minStockThreshold: minStockThreshold,
    maxStockThreshold: maxStockThreshold,
    stockOrderTriggerThreshold: stockOrderTriggerThreshold,
    productId: productId,
    supplierId: supplierId,
    shopId: shopId
  };
}

function makeInputObjectInputCreateVariantPrices(valueIncludingTax, valueExcludingTax, fromQuantity, toQuantity, priceId, param) {
  return {
    valueIncludingTax: valueIncludingTax,
    valueExcludingTax: valueExcludingTax,
    fromQuantity: fromQuantity,
    toQuantity: toQuantity,
    priceId: priceId
  };
}

let CreateVariantMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCreateVariant: serializeInputObjectInputCreateVariant,
  serializeInputObjectInputCreateVariantPrices: serializeInputObjectInputCreateVariantPrices,
  makeVariables: makeVariables,
  makeInputObjectInputCreateVariant: makeInputObjectInputCreateVariant,
  makeInputObjectInputCreateVariantPrices: makeInputObjectInputCreateVariantPrices
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let CreateVariantMutation_useWithVariables = include.useWithVariables;

let CreateVariantMutation = {
  CreateVariantMutation_inner: CreateVariantMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputCreateVariant: serializeInputObjectInputCreateVariant,
  serializeInputObjectInputCreateVariantPrices: serializeInputObjectInputCreateVariantPrices,
  makeVariables: makeVariables,
  makeInputObjectInputCreateVariant: makeInputObjectInputCreateVariant,
  makeInputObjectInputCreateVariantPrices: makeInputObjectInputCreateVariantPrices,
  use: use,
  useWithVariables: CreateVariantMutation_useWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["mutation createStockActivity($input: InputCreateStockActivity!)  {\ncreateStockActivity(input: $input)  {\n__typename  \nid  \n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.createStockActivity;
  return {
    createStockActivity: {
      __typename: value$1.__typename,
      id: value$1.id
    }
  };
}

function serialize$1(value) {
  let value$1 = value.createStockActivity;
  let value$2 = value$1.id;
  let value$3 = value$1.__typename;
  let createStockActivity = {
    __typename: value$3,
    id: value$2
  };
  return {
    createStockActivity: createStockActivity
  };
}

function serializeInputObjectInputCreateStockActivity(inp) {
  let a = inp.kind;
  let a$1 = inp.comment;
  let a$2 = inp.reason;
  let a$3 = inp.stockKeepingUnit;
  let a$4 = inp.capacityUnit;
  let a$5 = inp.capacityPrecision;
  return {
    kind: a === "DELIVERY_RECEIPT" ? "DELIVERY_RECEIPT" : (
        a === "RESET" ? "RESET" : (
            a === "INCOMING_TRANSFER" ? "INCOMING_TRANSFER" : (
                a === "DELIVERY" ? "DELIVERY" : (
                    a === "REFUND" ? "REFUND" : (
                        a === "LOSS" ? "LOSS" : (
                            a === "CREDIT_MEMO" ? "CREDIT_MEMO" : (
                                a === "SALE" ? "SALE" : (
                                    a === "RECEPTION" ? "RECEPTION" : "OUTGOING_TRANSFER"
                                  )
                              )
                          )
                      )
                  )
              )
          )
      ),
    quantity: inp.quantity,
    comment: a$1 !== undefined ? a$1 : undefined,
    reason: a$2 !== undefined ? (
        a$2 === "DAMAGE" ? "DAMAGE" : (
            a$2 === "OUTDATED_DLUO" ? "OUTDATED_DLUO" : (
                a$2 === "SALE_BY_GLASS" ? "SALE_BY_GLASS" : (
                    a$2 === "THEFT" ? "THEFT" : (
                        a$2 === "TASTING" ? "TASTING" : (
                            a$2 === "LOSS" ? "LOSS" : (
                                a$2 === "OTHER" ? "OTHER" : (
                                    a$2 === "TRADE_IN_SUPPLIER" ? "TRADE_IN_SUPPLIER" : "CORKY"
                                  )
                              )
                          )
                      )
                  )
              )
          )
      ) : undefined,
    stockKeepingUnit: a$3 !== undefined ? a$3 : undefined,
    capacityUnit: a$4 !== undefined ? a$4 : undefined,
    capacityPrecision: a$5 !== undefined ? a$5 : undefined,
    variantId: inp.variantId,
    deviceId: inp.deviceId,
    shopId: inp.shopId
  };
}

function serializeVariables$1(inp) {
  return {
    input: serializeInputObjectInputCreateStockActivity(inp.input)
  };
}

function makeVariables$1(input, param) {
  return {
    input: input
  };
}

function makeInputObjectInputCreateStockActivity(kind, quantity, comment, reason, stockKeepingUnit, capacityUnit, capacityPrecision, variantId, deviceId, shopId, param) {
  return {
    kind: kind,
    quantity: quantity,
    comment: comment,
    reason: reason,
    stockKeepingUnit: stockKeepingUnit,
    capacityUnit: capacityUnit,
    capacityPrecision: capacityPrecision,
    variantId: variantId,
    deviceId: deviceId,
    shopId: shopId
  };
}

let CreateStockActivity_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputCreateStockActivity: serializeInputObjectInputCreateStockActivity,
  makeVariables: makeVariables$1,
  makeInputObjectInputCreateStockActivity: makeInputObjectInputCreateStockActivity
};

let include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let CreateStockActivity_useWithVariables = include$1.useWithVariables;

let CreateStockActivity = {
  CreateStockActivity_inner: CreateStockActivity_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputCreateStockActivity: serializeInputObjectInputCreateStockActivity,
  makeVariables: makeVariables$1,
  makeInputObjectInputCreateStockActivity: makeInputObjectInputCreateStockActivity,
  use: use$1,
  useWithVariables: CreateStockActivity_useWithVariables
};

let Raw$2 = {};

let query$2 = Client.gql(["mutation updateVariant($id: ID!, $input: InputUpdateVariant!)  {\nupdateVariant(id: $id, input: $input)  {\n__typename  \nid  \nupdatedAt  \npurchasedPrice  \nname  \nformattedName  \ncapacityValue  \ncapacityUnit  \ncapacityPrecision  \nyear  \nalcoholVolume  \nean13  \nstockKeepingUnit  \npriceLookUpCode  \ninternalCode  \n}\n\n}\n"]);

function parse$2(value) {
  let value$1 = value.updateVariant;
  let value$2 = value$1.purchasedPrice;
  let value$3 = value$1.capacityValue;
  let value$4 = value$1.capacityUnit;
  let value$5 = value$1.capacityPrecision;
  let value$6 = value$1.year;
  let value$7 = value$1.alcoholVolume;
  let value$8 = value$1.ean13;
  let value$9 = value$1.stockKeepingUnit;
  let value$10 = value$1.priceLookUpCode;
  let value$11 = value$1.internalCode;
  return {
    updateVariant: {
      __typename: value$1.__typename,
      id: value$1.id,
      updatedAt: Scalar.Datetime.parse(value$1.updatedAt),
      purchasedPrice: !(value$2 == null) ? value$2 : undefined,
      name: value$1.name,
      formattedName: value$1.formattedName,
      capacityValue: !(value$3 == null) ? value$3 : undefined,
      capacityUnit: !(value$4 == null) ? value$4 : undefined,
      capacityPrecision: !(value$5 == null) ? value$5 : undefined,
      year: !(value$6 == null) ? value$6 : undefined,
      alcoholVolume: !(value$7 == null) ? value$7 : undefined,
      ean13: !(value$8 == null) ? value$8 : undefined,
      stockKeepingUnit: !(value$9 == null) ? value$9 : undefined,
      priceLookUpCode: !(value$10 == null) ? value$10 : undefined,
      internalCode: !(value$11 == null) ? value$11 : undefined
    }
  };
}

function serialize$2(value) {
  let value$1 = value.updateVariant;
  let value$2 = value$1.internalCode;
  let internalCode = value$2 !== undefined ? value$2 : null;
  let value$3 = value$1.priceLookUpCode;
  let priceLookUpCode = value$3 !== undefined ? value$3 : null;
  let value$4 = value$1.stockKeepingUnit;
  let stockKeepingUnit = value$4 !== undefined ? value$4 : null;
  let value$5 = value$1.ean13;
  let ean13 = value$5 !== undefined ? value$5 : null;
  let value$6 = value$1.alcoholVolume;
  let alcoholVolume = value$6 !== undefined ? value$6 : null;
  let value$7 = value$1.year;
  let year = value$7 !== undefined ? value$7 : null;
  let value$8 = value$1.capacityPrecision;
  let capacityPrecision = value$8 !== undefined ? value$8 : null;
  let value$9 = value$1.capacityUnit;
  let capacityUnit = value$9 !== undefined ? value$9 : null;
  let value$10 = value$1.capacityValue;
  let capacityValue = value$10 !== undefined ? value$10 : null;
  let value$11 = value$1.formattedName;
  let value$12 = value$1.name;
  let value$13 = value$1.purchasedPrice;
  let purchasedPrice = value$13 !== undefined ? value$13 : null;
  let value$14 = value$1.updatedAt;
  let value$15 = Scalar.Datetime.serialize(value$14);
  let value$16 = value$1.id;
  let value$17 = value$1.__typename;
  let updateVariant = {
    __typename: value$17,
    id: value$16,
    updatedAt: value$15,
    purchasedPrice: purchasedPrice,
    name: value$12,
    formattedName: value$11,
    capacityValue: capacityValue,
    capacityUnit: capacityUnit,
    capacityPrecision: capacityPrecision,
    year: year,
    alcoholVolume: alcoholVolume,
    ean13: ean13,
    stockKeepingUnit: stockKeepingUnit,
    priceLookUpCode: priceLookUpCode,
    internalCode: internalCode
  };
  return {
    updateVariant: updateVariant
  };
}

function serializeInputObjectInputUpdateVariantMetaData(inp) {
  let a = inp.shopifyVariantId;
  return {
    shopifyVariantId: a !== undefined ? a : undefined
  };
}

function serializeInputObjectInputUpdateVariant(inp) {
  let a = inp.stockKeepingUnit;
  let a$1 = inp.name;
  let a$2 = inp.purchasedPrice;
  let a$3 = inp.year;
  let a$4 = inp.capacityValue;
  let a$5 = inp.capacityUnit;
  let a$6 = inp.capacityPrecision;
  let a$7 = inp.alcoholVolume;
  let a$8 = inp.ean13;
  let a$9 = inp.internalNote;
  let a$10 = inp.metadata;
  let a$11 = inp.tastingNote;
  let a$12 = inp.packaging;
  let a$13 = inp.internalCode;
  let a$14 = inp.priceLookUpCode;
  let a$15 = inp.supplierId;
  let a$16 = inp.minStockThreshold;
  let a$17 = inp.maxStockThreshold;
  let a$18 = inp.stockOrderTriggerThreshold;
  return {
    stockKeepingUnit: a !== undefined ? a : undefined,
    name: a$1 !== undefined ? a$1 : undefined,
    purchasedPrice: a$2 !== undefined ? a$2 : undefined,
    year: a$3 !== undefined ? a$3 : undefined,
    capacityValue: a$4 !== undefined ? a$4 : undefined,
    capacityUnit: a$5 !== undefined ? a$5 : undefined,
    capacityPrecision: a$6 !== undefined ? a$6 : undefined,
    alcoholVolume: a$7 !== undefined ? a$7 : undefined,
    ean13: a$8 !== undefined ? a$8 : undefined,
    internalNote: a$9 !== undefined ? a$9 : undefined,
    metadata: a$10 !== undefined ? serializeInputObjectInputUpdateVariantMetaData(a$10) : undefined,
    tastingNote: a$11 !== undefined ? a$11 : undefined,
    packaging: a$12 !== undefined ? a$12 : undefined,
    internalCode: a$13 !== undefined ? a$13 : undefined,
    priceLookUpCode: a$14 !== undefined ? a$14 : undefined,
    supplierId: a$15 !== undefined ? a$15 : undefined,
    minStockThreshold: a$16 !== undefined ? a$16 : undefined,
    maxStockThreshold: a$17 !== undefined ? a$17 : undefined,
    stockOrderTriggerThreshold: a$18 !== undefined ? a$18 : undefined
  };
}

function serializeVariables$2(inp) {
  return {
    id: inp.id,
    input: serializeInputObjectInputUpdateVariant(inp.input)
  };
}

function makeVariables$2(id, input, param) {
  return {
    id: id,
    input: input
  };
}

function makeInputObjectInputUpdateVariant(stockKeepingUnit, name, purchasedPrice, year, capacityValue, capacityUnit, capacityPrecision, alcoholVolume, ean13, internalNote, metadata, tastingNote, packaging, internalCode, priceLookUpCode, supplierId, minStockThreshold, maxStockThreshold, stockOrderTriggerThreshold, param) {
  return {
    stockKeepingUnit: stockKeepingUnit,
    name: name,
    purchasedPrice: purchasedPrice,
    year: year,
    capacityValue: capacityValue,
    capacityUnit: capacityUnit,
    capacityPrecision: capacityPrecision,
    alcoholVolume: alcoholVolume,
    ean13: ean13,
    internalNote: internalNote,
    metadata: metadata,
    tastingNote: tastingNote,
    packaging: packaging,
    internalCode: internalCode,
    priceLookUpCode: priceLookUpCode,
    supplierId: supplierId,
    minStockThreshold: minStockThreshold,
    maxStockThreshold: maxStockThreshold,
    stockOrderTriggerThreshold: stockOrderTriggerThreshold
  };
}

function makeInputObjectInputUpdateVariantMetaData(shopifyVariantId, param) {
  return {
    shopifyVariantId: shopifyVariantId
  };
}

let UpdateVariantMutation_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData,
  makeVariables: makeVariables$2,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData
};

let include$2 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$2,
  Raw: Raw$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2
});

let use$2 = include$2.use;

let UpdateVariantMutation_useWithVariables = include$2.useWithVariables;

let UpdateVariantMutation = {
  UpdateVariantMutation_inner: UpdateVariantMutation_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData,
  makeVariables: makeVariables$2,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData,
  use: use$2,
  useWithVariables: UpdateVariantMutation_useWithVariables
};

function makeCreateVariantInput(state, productId, shopId) {
  if (state.name === "") {
    throw {
      RE_EXN_ID: CreateVariantInput_NameError,
      Error: new Error()
    };
  }
  let capacityValue = state.capacityValue;
  let exit = 0;
  if (capacityValue !== undefined && state.bulk) {
    if (capacityValue > 0) {
      throw {
        RE_EXN_ID: CreateVariantInput_CapacityValueError,
        Error: new Error()
      };
    }
    exit = 2;
  } else {
    exit = 2;
  }
  if (exit === 2) {
    let maxStockThreshold = state.maxStockThreshold;
    let exit$1 = 0;
    let exit$2 = 0;
    if (maxStockThreshold !== undefined) {
      let minStockThreshold = state.minStockThreshold;
      if (minStockThreshold !== undefined) {
        if (minStockThreshold >= maxStockThreshold) {
          throw {
            RE_EXN_ID: CreateVariantInput_StockThresholdsInvalid,
            Error: new Error()
          };
        }
        exit$2 = 4;
      } else {
        exit$1 = 3;
      }
    } else {
      exit$2 = 4;
    }
    if (exit$2 === 4) {
      let minStockThreshold$1 = state.minStockThreshold;
      if (minStockThreshold$1 !== undefined) {
        let trigger = state.stockOrderTriggerThreshold;
        if (trigger !== undefined) {
          if (minStockThreshold$1 > trigger) {
            throw {
              RE_EXN_ID: CreateVariantInput_StockThresholdsInvalid,
              Error: new Error()
            };
          }
          exit$1 = 3;
        }
      } else {
        exit$1 = 3;
      }
    }
    if (exit$1 === 3 && maxStockThreshold !== undefined) {
      let trigger$1 = state.stockOrderTriggerThreshold;
      if (trigger$1 !== undefined && trigger$1 >= maxStockThreshold) {
        throw {
          RE_EXN_ID: CreateVariantInput_StockThresholdsInvalid,
          Error: new Error()
        };
      }
    }
  }
  let unit = state.capacityUnit;
  let tmp = state.supplierId === "" ? undefined : state.supplierId;
  return makeInputObjectInputCreateVariant(state.stockKeepingUnit, state.name, Stdlib_Option.getOr(state.purchasePrice, 0), Stdlib_Option.map(state.year, prim => prim | 0), state.capacityUnit !== undefined ? state.capacityValue : undefined, unit !== undefined ? unit : undefined, state.bulk ? CatalogVariant.defaultBulkCapacityPrecision : undefined, state.alcoholVolume, state.ean13, state.bulk, undefined, state.internalCode, state.priceLookUpCode.value, Stdlib_Option.map(state.minStockThreshold, prim => prim | 0), Stdlib_Option.map(state.maxStockThreshold, prim => prim | 0), Stdlib_Option.map(state.stockOrderTriggerThreshold, prim => prim | 0), productId, tmp, shopId, undefined);
}

function useCreateVariant() {
  let match = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  let match$1 = use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutateStockActivity = match$1[0];
  let activeShop = Auth.useActiveShop();
  return React.useCallback((productId, state) => {
    let productId$1;
    if (productId !== undefined) {
      productId$1 = productId;
    } else {
      throw {
        RE_EXN_ID: CreateVariant_FormIdNotFound,
        Error: new Error()
      };
    }
    let shopId;
    if (activeShop !== undefined) {
      shopId = activeShop.id;
    } else {
      throw {
        RE_EXN_ID: CreateVariant_ShopIdNotFound,
        Error: new Error()
      };
    }
    let deviceId;
    if (activeShop !== undefined) {
      deviceId = activeShop.activeWebDeviceId;
    } else {
      throw {
        RE_EXN_ID: CreateVariant_DeviceIdNotFound,
        Error: new Error()
      };
    }
    let input = makeCreateVariantInput(state, productId$1, shopId);
    let variantPrices = state.variantPrices;
    let variantPricesInput = variantPrices !== undefined ? variantPrices.map(param => makeInputObjectInputCreateVariantPrices(param.valueIncludingTax, param.valueExcludingTax, undefined, undefined, param.priceId, undefined)) : [];
    return Future.flatMapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      input: input,
      variantPricesInput: variantPricesInput
    })), undefined, param => {
      let quantity = state.initialStockQuantity;
      let match = param.createVariant;
      let capacityPrecision = match.capacityPrecision;
      let cku = match.cku;
      if (quantity === undefined) {
        return Future.value({
          TAG: "Ok",
          _0: cku
        });
      }
      if (quantity <= 0) {
        return Future.value({
          TAG: "Ok",
          _0: cku
        });
      }
      let input = makeInputObjectInputCreateStockActivity("DELIVERY", StockQuantity.toRawValue(capacityPrecision, quantity), state.initialStockComment, undefined, undefined, state.capacityUnit, capacityPrecision, match.id, deviceId, shopId, undefined);
      let variables = {
        input: input
      };
      return Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutateStockActivity(undefined, undefined, undefined, undefined, undefined, undefined, undefined, variables)), undefined, param => cku);
    });
  }, [activeShop]);
}

function makeUpdateVariantInput(state) {
  let tmp;
  if (state.name === "") {
    throw {
      RE_EXN_ID: UpdateVariantInput_NameError,
      Error: new Error()
    };
  }
  tmp = state.name;
  let tmp$1;
  let exit = 0;
  if (state.capacityUnit !== undefined) {
    let capacityValue = state.capacityValue;
    if (capacityValue !== undefined) {
      tmp$1 = capacityValue;
    } else {
      exit = 1;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp$1 = null;
  }
  return makeInputObjectInputUpdateVariant(state.stockKeepingUnit, tmp, undefined, Stdlib_Option.mapOr(state.year, null, prim => prim | 0), tmp$1, Stdlib_Option.getOr(state.capacityUnit, null), undefined, Stdlib_Option.getOr(state.alcoholVolume, null), state.ean13, undefined, undefined, undefined, undefined, state.internalCode, Stdlib_Option.getOr(state.priceLookUpCode.value, null), undefined, undefined, undefined, undefined, undefined);
}

function useUpdateVariant() {
  let match = use$2(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  return React.useCallback((variantId, state) => {
    let id;
    if (variantId !== undefined) {
      id = variantId;
    } else {
      throw {
        RE_EXN_ID: UpdateVariant_FormIdNotFound,
        Error: new Error()
      };
    }
    let input = makeUpdateVariantInput(state);
    return Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: id,
      input: input
    })), undefined, param => id);
  }, []);
}

function useCreateProductAndVariant(productValues) {
  let createProduct = CatalogProductEditFormMutations.useCreateProduct();
  let createVariant = useCreateVariant();
  return React.useCallback((param, state) => {
    let productState;
    if (productValues !== undefined) {
      productState = productValues;
    } else {
      throw {
        RE_EXN_ID: CreateProductAndVariant_ProductValuesNotFound,
        Error: new Error()
      };
    }
    return Future.mapOk(Future.flatMapOk(createProduct(undefined, productState), undefined, productId => createVariant(productId, state)), undefined, result => result);
  }, [productValues]);
}

export {
  CreateProductAndVariant_ProductValuesNotFound,
  CreateVariantInput_NameError,
  CreateVariantInput_CapacityValueError,
  CreateVariantInput_StockThresholdsInvalid,
  CreateVariant_FormIdNotFound,
  CreateVariant_ShopIdNotFound,
  CreateVariant_DeviceIdNotFound,
  UpdateVariantInput_NameError,
  UpdateVariant_FormIdNotFound,
  CreateVariantMutation,
  CreateStockActivity,
  UpdateVariantMutation,
  makeCreateVariantInput,
  useCreateVariant,
  makeUpdateVariantInput,
  useUpdateVariant,
  useCreateProductAndVariant,
}
/* query Not a pure module */
